export interface RateLimiterConfig {
  windowMs: number // Time window in milliseconds
  maxEvents: number // Maximum number of events allowed in the window
}

export class RateLimiter {
  private eventTimes: number[] = []

  constructor(private readonly config: Readonly<RateLimiterConfig>) {}

  check(): boolean {
    this.eventTimes.push(Date.now())
    this.eventTimes = this.eventTimes.filter((t) => t > Date.now() - this.config.windowMs)

    if (this.eventTimes.length > this.config.maxEvents) {
      this.reset()
      return true
    }
    return false
  }

  reset(): void {
    this.eventTimes = []
  }
}
